import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  IconButton,
  AppBar,
  Toolbar,
  Typography,
  useScrollTrigger,
  CssBaseline,
  Drawer,
  Collapse,
  ListItem,
  Popover,
  List,
  ListItemText,
  Fade,
  Paper,
  Button,
} from "@mui/material";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Menu } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// import s2tLogo from "../../Images/s2tlogo.png";
import { commonCss } from "../../CssStyle/commonCss";
import { navProductMenu, navServiceMenu } from "../Config/config";

// function ElevationScroll(props) {
//   const { children } = props;
//   const trigger = useScrollTrigger();

//   return React.cloneElement(children, {
//     elevation: trigger ? 4 : 0, // Change elevation based on scroll
//     style: {
//       backgroundColor: trigger ? commonCss.navScrollBg : commonCss.navNormalBg, // Change color based on scroll
//       transition: "background-color 0.3s ease, box-shadow 0.3s ease", // Smooth transition
//     },
//   });
// }
const Nav = (props) => {

  const [searchParams,setSearchParams]=useSearchParams()
  const searchTitle=searchParams.get("serviceTitle")
  console.log(searchTitle)

  
  const drawerWidth = 340;
  // const { window } = props;
  const origin=window.location.origin
  const currentPath=window.location.href.split(`${origin}`)[1]
  const currentPathSubmenu="/"+currentPath.split("/")[1]
  const currentPathSubmenu1=currentPath.split("?")[0]


  const navigate = useNavigate();

  const serviceRef = useRef(null);
  const productRef = useRef(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(false);
  const [anchorElProductDrawer, setAnchorElProductDrawer] = useState(false);
  const [anchorElDrawer, setAnchorElDrawer] = useState(false);
  const [anchorElProduct, setAnchorElProduct] = useState(false);
  const [bgColor,setBgColor]=useState("transparent")


  const handleScroll = () => {
        if (window.scrollY > 50) {
          setBgColor(commonCss.navScrollBg); // Change to dark color when scrolled down
        } else {
          setBgColor("transparent"); // Change back to transparent when at the top
        }
      };
    
      useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }, []);
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };
  const handleMouseEnter = () => {
    if (serviceRef.current) {
      setAnchorEl(serviceRef.current);
    }
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  const handleMouseEnterProduct = () => {
    if (serviceRef.current) {
      setAnchorElProduct(serviceRef.current);
    }
  };

  const handleMouseLeaveProduct = () => {
    setAnchorElProduct(null);
  };

  const serviceDrawer=()=>{
    setAnchorElDrawer(!anchorElDrawer)
  }
  const productDrawer=()=>{
    setAnchorElProductDrawer(!anchorElProductDrawer)
  }

  const open = Boolean(anchorEl);
  const openProduct = Boolean(anchorElProduct);
  const container =
    props.window !== undefined ? () => props.window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      {/* <ElevationScroll {...props}> */}
        <AppBar component="nav" elevation={bgColor==="transparent"?0:4} sx={{backgroundColor:bgColor,maxHeight:"20vh" }}>
          <Toolbar sx={{p:"0.5rem"}}>
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                color: commonCss.navCompanyNameColor,
                // gap: "0.1rem",
                alignItems: "flex-end",
                  cursor:"pointer"
              }}
              onClick={()=>{navigate("/")}}
            >
              <img
                src={"/Images/s2tlogo.png"}
                alt="s2tlogo"
                style={{ width: "auto", height: "9vh" }}
              />
              <Typography variant="h6" sx={{ color: commonCss.blue,fontFamily: `-apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, 
      'Helvetica Neue', 'Fira Sans', Ubuntu, Oxygen, 'Oxygen Sans', Cantarell, 
      'Droid Sans', 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 
      'Lucida Grande', Helvetica, Arial, sans-serif`,fontWeight:500 }}>
                SOLVER THOUGHTS TECHNOLOGIES
              </Typography>
            </Box>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="end"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { lg: "none" } }}
            >
              <Menu sx={{ color: commonCss.black }} />
            </IconButton>
            <Box
              sx={{
                display: { xs: "none", lg: "flex" },
                width: "65%",
                // gap: "1rem",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "1.2rem",
                fontWeight: 500,
                color: commonCss.navTitleColor,
              }}
            >
              <Link to="/">
                <Typography
                  sx={{
                    color: currentPath==="/"?commonCss.blue:commonCss.navTitleColor,
                    ":hover": {
                      color: commonCss.blue,
                    },
                    fontWeight:500,
                    position: "relative",
                    padding: "10px 10px",
                    textTransform: "none",
                    textWrap:"nowrap",
                    overflow: "hidden", // Ensure the border doesn't overflow
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      left: "50%", // Start from the center
                      bottom: 0,
                      width: "0%", // Start with no width
                      height: "2px",
                      backgroundColor:  commonCss.blue,
                      transition: "width 0.2s ease-in", // Transition the width
                      transform: "translateX(-50%)", // Center the border
                    },
                    "&:hover::after": {
                      width: "50%", // Expand to full width on hover
                    },
                  }}
                >
                  Home
                </Typography>
              </Link>
             
              <Box sx={{ position: "relative" }}>
                <Link to="">
                  <Typography
                    ref={serviceRef}
                    sx={{
                      color: currentPath==="/services"?commonCss.blue:commonCss.navTitleColor,
                      ":hover": {
                        color:  commonCss.blue,
                      },
                      fontWeight:500,
                      position: "relative",
                      padding: "10px 10px",
                      textTransform: "none",
                      textWrap:"nowrap",
                      overflow: "hidden", // Ensure the border doesn't overflow
                      "&::after": {
                        content: '""',
                        position: "absolute",
                        left: "50%", // Start from the center
                        bottom: 0,
                        width: "0%", // Start with no width
                        height: "2px",
                        backgroundColor:  commonCss.blue,
                        transition: "width 0.2s ease-in", // Transition the width
                        transform: "translateX(-50%)", // Center the border
                      },
                      "&:hover::after": {
                        width: "50%", // Expand to full width on hover
                      },
                      display: "flex",
                      alignItems: "center",
                      gap: "0.2rem",
                    }}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    Services <KeyboardArrowDownIcon />
                  </Typography>
                </Link>
                {/* <Paper
                  sx={{
                    display: open ? "block" : "none",
                    position: "fixed",
                    mt: "0.1rem",
                  }}
                > */}
                  <Fade
                    // id={id}
                    sx={{
                      display: open ? "block" : "none",
                      position: "fixed",
                      mt: "0.1rem",
                      backgroundColor:"white",
                      borderRadius:"4px",
                      boxShadow:"0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)"
                    }}
                    timeout={650}
                    in={open}
                    anchorEl={anchorEl}
                    onClose={handleMouseLeave}
                    onMouseEnter={handleMouseEnter} // Keep popover open when hovering over it
                    onMouseLeave={handleMouseLeave} // Close popover when mouse leaves
                  >
                    <List>
                      {navServiceMenu.map((item) => (
                        <ListItem
                          button
                          key={item.name}
                          sx={{ cursor: "pointer" }}
                          onClick={() => {
                            navigate(item.link);
                          }}
                        >
                          <ListItemText
                            primary={item.name}
                            sx={{
                              color: commonCss.navTitleColor,
                              ":hover": {
                                color: commonCss.blue,
                              },
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Fade>
                {/* </Paper> */}
              </Box>
              <Box sx={{ position: "relative" }}>
             
                  <Typography
                    ref={productRef}
                    sx={{
                       cursor:"pointer",
                      color: currentPathSubmenu==="/products"?commonCss.blue:commonCss.navTitleColor,
                      ":hover": {
                        color: commonCss.blue,
                      },
                      position: "relative",
                      padding: "10px 10px",
                      fontWeight:500,
                      textTransform: "none",
                      textWrap:"nowrap",
                      overflow: "hidden", // Ensure the border doesn't overflow
                      "&::after": {
                        content: '""',
                        position: "absolute",
                        left: "40%", // Start from the center
                        bottom: 0,
                        width: "0%", // Start with no width
                        height: "2px",
                        backgroundColor:  commonCss.blue,
                        transition: "width 0.2s ease-in", // Transition the width
                        transform: "translateX(-50%)", // Center the border
                      },
                      "&:hover::after": {
                        width: "50%", // Expand to full width on hover
                      },
                      display: "flex",
                      alignItems: "center",
                      gap: "0.2rem",
                    }}
                    onMouseEnter={handleMouseEnterProduct}
                    onMouseLeave={handleMouseLeaveProduct}
                  >
                    Products <KeyboardArrowDownIcon />
                  </Typography>
              
                {/* <Paper
                 
                > */}
                  <Fade
                    // id={id}
                    sx={{
                      display: openProduct ? "block" : "none",
                      position: "fixed",
                      mt: "0.1rem",
                      backgroundColor:"white",
                      borderRadius:"4px",
                      boxShadow:"0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)"
                    }}
                    timeout={650}
                    in={openProduct}
                    anchorEl={anchorElProduct}
                    onClose={handleMouseLeaveProduct}
                    onMouseEnter={handleMouseEnterProduct} // Keep popover open when hovering over it
                    onMouseLeave={handleMouseLeaveProduct} // Close popover when mouse leaves
                  >
                    <List>
                      {navProductMenu.map((item) => (
                        <ListItem
                          button
                          key={item.name}
                          sx={{ cursor: "pointer" }}
                          onClick={() => {
                            navigate(item.link);
                          }}
                        >
                          <ListItemText
                            primary={item.name}
                            sx={{
                              color: commonCss.navTitleColor,
                              ":hover": {
                                color: commonCss.blue,
                              },
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Fade>
                {/* </Paper> */}
              </Box>
              <Link to="/hrdf">
                <Typography
                  sx={{
                    color: currentPath==="/hrdf"?commonCss.blue:commonCss.navTitleColor,
                    ":hover": {
                      color:  commonCss.blue,
                    },
                    fontWeight:500,
                    position: "relative",
                    padding: "10px 10px",
                    textTransform: "none",
                    textWrap:"nowrap",
                    overflow: "hidden", // Ensure the border doesn't overflow
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      left: "50%", // Start from the center
                      bottom: 0,
                      width: "0%", // Start with no width
                      height: "2px",
                      backgroundColor: commonCss.blue,
                      transition: "width 0.2s ease-in", // Transition the width
                      transform: "translateX(-50%)", // Center the border
                    },
                    "&:hover::after": {
                      width: "50%", // Expand to full width on hover
                    },
                  }}
                >
                  HRDF Training
                </Typography>
              </Link>
              <Link to="/outsourcing">
                <Typography
                  sx={{
                    color: currentPath==="/outsourcing"?commonCss.blue:commonCss.navTitleColor,
                    ":hover": {
                      color:  commonCss.blue,
                    },
                    fontWeight:500,
                    position: "relative",
                    padding: "10px 10px",
                    textTransform: "none",
                    textWrap:"nowrap",
                    overflow: "hidden", // Ensure the border doesn't overflow
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      left: "50%", // Start from the center
                      bottom: 0,
                      width: "0%", // Start with no width
                      height: "2px",
                      backgroundColor: commonCss.blue,
                      transition: "width 0.2s ease-in", // Transition the width
                      transform: "translateX(-50%)", // Center the border
                    },
                    "&:hover::after": {
                      width: "50%", // Expand to full width on hover
                    },
                  }}
                
                >
                  Outsourcing
                </Typography>
              </Link>
              <Link to="/aboutus">
                <Typography
                  sx={{
                    color: currentPath==="/aboutus"?commonCss.blue:commonCss.navTitleColor,
                    ":hover": {
                      color:  commonCss.blue,
                    },
                    fontWeight:500,
                    position: "relative",
                    padding: "10px 10px",
                    textTransform: "none",
                    textWrap:"nowrap",
                    overflow: "hidden", // Ensure the border doesn't overflow
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      left: "50%", // Start from the center
                      bottom: 0,
                      width: "0%", // Start with no width
                      height: "2px",
                      backgroundColor: commonCss.blue,
                      transition: "width 0.2s ease-in", // Transition the width
                      transform: "translateX(-50%)", // Center the border
                    },
                    "&:hover::after": {
                      width: "50%", // Expand to full width on hover
                    },
                  }}
                >
                  About Us
                </Typography>
              </Link>
              <Button
                sx={{
                  backgroundColor: commonCss.buttonBg,
                  color: commonCss.buttonText,
                  padding:"0.5rem",
                  textTransform:"none",
                  width:"10vw",
                  fontWeight:500,
                  fontSize:"0.95rem",
                  ml:5,
                  borderRadius:"30px",
                  ":hover":{
                    background:commonCss.blue,
                  
                  }
                }}

                onClick={()=>{navigate("/contactus")}}
              >
                Contact
              </Button>
            </Box>
          </Toolbar>
        </AppBar>
      {/* </ElevationScroll> */}

      <Drawer
        container={container}
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", lg: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
            backgroundColor:"#cde4fc"
          },
        }}
      >
       <Box sx={{padding:"2rem"}}>
               <Link to="/">
                <Typography
                  sx={{
                    color: currentPath==="/"?commonCss.blue:commonCss.navTitleColor,
                    ":hover": {
                      color: commonCss.blue,
                    },
                    fontWeight:500,
                    position: "relative",
                    padding: "10px 10px",
                    textTransform: "none",
                    overflow: "hidden", // Ensure the border doesn't overflow
                    cursor:"pointer",
                    fontSize:"1.2rem"

                  }}
                  onClick={()=>{
                    setMobileOpen(false)
                    // navigate("/")
                  }}
                >
                  Home
                </Typography>
                </Link>
              
               
              
              <Box >
               
                  <Typography
                    sx={{
                      
                      color: (currentPathSubmenu1==="/services")?commonCss.blue:commonCss.navTitleColor,
                      fontWeight:500,
                      padding: "10px 10px",
                      textTransform: "none",
                      overflow: "hidden", // Ensure the border doesn't overflow
                     
                      display: "flex",
                      alignItems: "center",
                      gap: "0.2rem",
                      fontSize:"1.2rem"
                    }}
                    onClick={serviceDrawer}
                  >
                    Services <KeyboardArrowDownIcon />
                  </Typography>
              
                {/* <Paper
                  sx={{
                    display: open ? "block" : "none",
                    position: "fixed",
                    mt: "0.1rem",
                  }}
                > */}
                  <Collapse
                    // id={id}
                    sx={{
                      
                     
                      ml: "1.5rem",
                     
                    }}
                    timeout={450}
                    in={anchorElDrawer}
                    anchorEl={anchorElDrawer}
                   
                  >
                    <List>
                      {navServiceMenu.map((item) => (
                        <Link to={item.link} key={item.name}>
                        <ListItem
                          button
                          
                          sx={{ cursor: "pointer" }}
                          onClick={() => {
                            setMobileOpen(false)
                            // navigate(item.link);
                          }}
                        >
                          
                          <ListItemText
                            primary={item.name}
                            sx={{
                              color: currentPath===item.link?commonCss.blue:commonCss.navTitleColor,
                              "& .MuiListItemText-primary":{
                                      fontSize:"1.15rem"
                              }
                              // ":hover": {
                              //   color: commonCss.blue,
                              // },
                            }}
                          />
                          
                        </ListItem>
                        </Link>
                      ))}
                    </List>
                  </Collapse>
                {/* </Paper> */}
              </Box>
              <Box >
                
                  <Typography
                    sx={{
                      color: (currentPathSubmenu==="/products")?commonCss.blue:commonCss.navTitleColor,
                     
                      fontWeight:500,
                      padding: "10px 10px",
                      textTransform: "none",
                      overflow: "hidden", // Ensure the border doesn't overflow
                     
                      display: "flex",
                      alignItems: "center",
                      gap: "0.2rem",
                      fontSize:"1.2rem"
                    }}
                    onClick={productDrawer}
                  >
                    Products <KeyboardArrowDownIcon />
                  </Typography>
              
                {/* <Paper
                  sx={{
                    display: open ? "block" : "none",
                    position: "fixed",
                    mt: "0.1rem",
                  }}
                > */}
                  <Collapse
                    // id={id}
                    sx={{
                      
                     
                      ml: "1.5rem",
                     
                    }}
                    timeout={450}
                    in={anchorElProductDrawer}
                    anchorEl={anchorElProductDrawer}
                   
                  >
                    <List>
                      {navProductMenu.map((item) => (
                        <Link to={item.link}   key={item.name}>
                        <ListItem
                          button
                        
                          sx={{ cursor: "pointer" }}
                          onClick={() => {
                            setMobileOpen(false)
                            // navigate(item.link);
                          }}
                        >
                          <ListItemText
                            primary={item.name}
                            sx={{
                              color: (currentPath===item.link)?commonCss.blue:commonCss.navTitleColor,
                              "& .MuiListItemText-primary":{
                                      fontSize:"1.15rem"
                              }
                              
                              // ":hover": {
                              //   color: commonCss.blue,
                              // },
                            }}
                          />
                        </ListItem>
                        </Link>
                      ))}
                    </List>
                  </Collapse>
                {/* </Paper> */}
              </Box>
              <Link to="/hrdf">
              <Typography
                  sx={{
                    color: currentPath==="/hrdf"?commonCss.blue:commonCss.navTitleColor,
                    ":hover": {
                      color:  commonCss.blue,
                    },
                    fontWeight:500,
                    position: "relative",
                    padding: "10px 10px",
                    textTransform: "none",
                    overflow: "hidden", // Ensure the border doesn't overflow
                    cursor:"pointer",
                    fontSize:"1.2rem"
                  }}
                  onClick={()=>{
                    setMobileOpen(false)
                    // navigate("/hrdf")
                  }}
                >
                  HRDF Training
                </Typography>
                </Link>
                <Link to="/aboutus">
                <Typography
                  sx={{
                    color: currentPath==="/outsourcing"?commonCss.blue:commonCss.navTitleColor,
                    ":hover": {
                      color:  commonCss.blue,
                    },
                    fontWeight:500,
                    position: "relative",
                    padding: "10px 10px",
                    textTransform: "none",
                    overflow: "hidden", // Ensure the border doesn't overflow
                    cursor:"pointer",
                    fontSize:"1.2rem"
                  }}
                  onClick={()=>{
                    setMobileOpen(false)
                    navigate("/outsourcing")
                  }}
                >
                  Outsourcing
                </Typography>
                <Typography
                  sx={{
                    color: currentPath==="/aboutus"?commonCss.blue:commonCss.navTitleColor,
                    ":hover": {
                      color:  commonCss.blue,
                    },
                    fontWeight:500,
                    position: "relative",
                    padding: "10px 10px",
                    textTransform: "none",
                    overflow: "hidden", // Ensure the border doesn't overflow
                    cursor:"pointer",
                    fontSize:"1.2rem"
                  }}
                  onClick={()=>{
                    setMobileOpen(false)
                    // navigate("/aboutus")
                  }}
                >
                  About Us
                </Typography>
                </Link>
                <Link to="/contactus">
                <Typography
                  sx={{
                    color: currentPath==="/contactus"?commonCss.blue:commonCss.navTitleColor,
                    ":hover": {
                      color:  commonCss.blue,
                    },
                    fontWeight:500,
                    position: "relative",
                    padding: "10px 10px",
                    textTransform: "none",
                    overflow: "hidden", // Ensure the border doesn't overflow
                    cursor:"pointer",
                    fontSize:"1.2rem"
                  }}
                  onClick={()=>{
                    setMobileOpen(false)
                    // navigate("/contactus")
                  }}
                >
                  Contact Us
                </Typography>
                </Link>
              {/* <Button
                sx={{
                  backgroundColor: commonCss.buttonBg,
                  color: commonCss.buttonText,
                  padding:"0.5rem",
                  textTransform:"none",
                  width:"40%",
                  fontWeight:500,
                  fontSize:"1.2rem",
                  borderRadius:"30px",
                  ":hover":{
                    background:commonCss.blue,
                  
                  }
                }}

                onClick={()=>{
                  setMobileOpen(false)
                  navigate("/contactus")}}
              >
                Contact
              </Button> */}

       </Box>
      </Drawer>
    </Box>
  );
};

export default Nav;
